/* src/app/quickbooks/send-purchases/send-purchases-filter/send-purchases-filter.component.scss */
body#themeTag :host ::ng-deep .p-checkbox-label {
  margin-top: 0.5rem;
}
/*# sourceMappingURL=send-purchases-filter.component.css.map */
